import { z } from "zod";
import { type ParserType, parser } from "./parser";
import { Tags } from "./tag";

export type MetricDefinition = ParserType<typeof Metric>;
export const MetricDefinition = parser(
  z.strictObject({
    kind: z.string(),
    defaultUnit: z.string(),
  }),
);

export type Metric = ParserType<typeof Metric>;
export const Metric = parser(
  z.strictObject({
    id: z.string(),
    name: z.string(),
    definition: MetricDefinition.schema,
    tags: Tags.schema,
  }),
);

export type Metrics = ParserType<typeof Metrics>;
export const Metrics = parser(z.array(Metric.schema));
